import { Injectable, inject } from '@angular/core';

import * as fromRoot from '@core/redux';
import { select, Store } from '@ngrx/store';
import * as _ from 'lodash';
import { combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { MessageModel } from '../models/message.model';

@Injectable({
  providedIn: 'root',
})
export class StoreMessageService {
  private store = inject<Store<fromRoot.State>>(Store);

  public limitVisible = 15;

  constructor() {}

  /**
   * Список сообщений для чата в разрезе задачи
   */
  getMessagesByTaskId(taskId: string) {
    const messageList$ = this.store.pipe(select(fromRoot.getMessageEntitiesByTask(taskId)));
    const inviteList$ = this.store.pipe(select(fromRoot.getInviteEntities));

    return combineLatest([messageList$, inviteList$]).pipe(
      filter(([messages, invites]) => invites.length > 0),
      map(([messages, invites]) => {
        const updatedMessages = messages.map(message => {
          const newMessage = new MessageModel();
          return newMessage.setAttributes({
            ...message,
            invite: _.find(invites, { userId: message.authorId as any }),
          });
        });
        const messageList = updatedMessages.slice(-this.limitVisible);
        const messageListHide =
          updatedMessages.length > this.limitVisible
            ? updatedMessages.slice(0, updatedMessages.length - this.limitVisible)
            : [];
        const messageListPinned = updatedMessages.filter((item: MessageModel) => item.isPin === true);

        return {
          messageList: messageList,
          messageListHide: messageListHide,
          messageListPinned: messageListPinned,
        };
      })
    );
  }
}
